import { motion } from "framer-motion";
import ProfileCard from "./ProfileCard";

interface TeamMemberCardProps {
  name: string;
  role: string;
  image?: string;
  index: number;
  totalInRow: number;
  categoryIcon?: string;
  email?: string;
  phone?: string;
}

const TeamMemberCard = ({ 
  name, 
  role, 
  image, 
  index, 
  totalInRow, 
  categoryIcon, 
  email = "",
  phone = ""
}: TeamMemberCardProps) => {
  const getAnimationVariant = () => {
    const positionInRow = index % totalInRow;
    const middleIndex = Math.floor(totalInRow / 2);
    
    if (positionInRow < middleIndex) {
      return { x: -80, opacity: 0, scale: 0.9 };
    } else if (positionInRow > middleIndex) {
      return { x: 80, opacity: 0, scale: 0.9 };
    } else {
      return { y: 40, scale: 0.8, opacity: 0 };
    }
  };

  const initialState = getAnimationVariant();

  // Generate handle from name (e.g., "John Doe" -> "johndoe")
  const handle = name.toLowerCase().replace(/\s+/g, '');

  return (
    <motion.div
      initial={initialState}
      whileInView={{ x: 0, y: 0, scale: 1, opacity: 1 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ 
        duration: 0.7, 
        delay: (index % totalInRow) * 0.08,
        ease: [0.25, 0.46, 0.45, 0.94]
      }}
      className="w-[200px] mx-auto" // Changed from max-w-[200px] to w-[200px]
    >
      <ProfileCard
        // Using the exact colors from your ProfileCard snippet
        innerGradient="linear-gradient(145deg, #60496e8c 0%, #71C4FF44 100%)" // Purple to blue with transparency
        behindGlowColor="rgba(125, 190, 255, 0.67)" // Light blue with transparency
        behindGlowSize="40px"
        miniAvatarUrl={image || ''}
        onContactClick={() => {
          console.log(`Contact ${name}`);
        }}
        
        // Optional props
        avatarUrl={image || ''}
        name={name}
        title={role}
        handle={handle}
        status={categoryIcon || 'Member'}
        showUserInfo={false}
        enableTilt={true}
        enableMobileTilt={true}
        mobileTiltSensitivity={5}
        className="w-full"
        
        // Additional props (set to defaults)
        iconUrl=""
        grainUrl=""
        behindGlowEnabled={true}
        contactText="Contact"
      />
    </motion.div>
  );
};

export default TeamMemberCard;